<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-message" icon-small title="مدیریت پیامک" color="accent">
			<div cols="12" class="pa-5 pt-0">
				<v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
					<v-tab :key="0">گزارش پیامک ها</v-tab>
					<v-tab :key="1">{{ isCloud ? 'شارژ پنل و تنظیمات' : 'تنظیمات پیامک ها' }}</v-tab>

					<v-tabs-items v-model="activeTab" touchless class="mt-3">
						<v-tab-item :key="0">
							<sms-list :mobile="mobile" :autoLoad="autoLoad" />
						</v-tab-item>
						<v-tab-item :key="1" style="">
							<v-row class="flex-column sms-row mx-2" style="position: sticky; top: 0;z-index: 2;">
								<v-col cols="12" md="12" class="text-left py-0">
									<!-- <v-spacer/> -->
									<v-btn class="" color="secondary" dark @click="dialogSmsPatternManager = true">
										مدیریت قالب های پیامک
									</v-btn>
									<v-btn class="mr-2" color="blue" :loading="loading" dark @click="saveSmsSettings()">
										ذخیره تنظیمات
									</v-btn>
								</v-col>
							</v-row>
							<v-row justify="center" class="ma-0">
								<v-col cols="10">
									<v-form ref="smsForm" class="mx-2" lazy-validation>
										<v-card class="px-3 py-5 mb-3">
											<v-row class="flex-column sms-row">
												<v-col cols="12" class="text-center">در صورت تمایل می توانید برای ارسال پیامک ها، یکی از پنل های
													پیامکی زیر را انتخاب کنید:</v-col>
												<v-col cols="12" md="4" class="">
													<v-combobox v-model="appSettings.defaultSmsPanel" clearable required :items="smsPanels" label="انتخاب پنل پیامک" single-line return-object item-text="title" item-value="id" />
												</v-col>
												<v-row v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 2">
													<v-col cols="12" md="4">
														<v-text-field class="left-input" v-model="appSettings.melliPayamakConfig.username" label="نام کاربری ملی پیامک" />
													</v-col>
													<v-col cols="12" md="4">
														<v-text-field class="left-input" v-model="appSettings.melliPayamakConfig.password" label="کلمه عبور ملی پیامک" />
													</v-col>
													<v-col cols="12" md="4">
														<v-text-field class="left-input" v-model="appSettings.melliPayamakConfig.from" label="شماره خط ملی پیامک" />
													</v-col>
												</v-row>
												<v-row justify="center" v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 3">
													<v-col cols="12" md="10">
														<v-text-field class="left-input" v-model="appSettings.kaveNegarConfig.apiKey" label="کلید رابط (api-key) کاوه نگار" />
													</v-col>
													<v-col cols="12" md="10">
														<v-text-field class="left-input" v-model="appSettings.kaveNegarConfig.sender" label="شماره خط کاوه نگار" />
													</v-col>
												</v-row>
											</v-row>
											<v-row class="flex-column sms-row" v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 1">
												<v-col cols="6" class="pb-0">
													<v-text-field class="center-input" :disabled="true" v-model="appSettings.smsCredit" label="اعتبار فعلی پیامک شما (تومان)" required />
												</v-col>
												<v-col cols="6" class="text-center pt-0">
													<v-btn class="mx-auto" color="secondary" dark @click="addSmsCreditCharge">
														<v-icon dark>
															mdi-plus-circle-outline
														</v-icon>
														افزایش اعتبار
													</v-btn>
												</v-col>
											</v-row>
											<v-row class="flex-column sms-row">
												<v-col cols="12" class="d-flex justify-center flex-column align-center">
													<v-switch v-model="appSettings.isRememberSmsActive" label="پیامک های یادآوری فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
												</v-col>
												<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
													<div class="grey--text" v-show="appSettings.isRememberSmsActive">
														پیامک ها راس چه ساعتی ارسال شوند؟
													</div>
													<date-picker v-show="appSettings.isRememberSmsActive" v-model="appSettings.dueDatedRememberSmsTime" type="time" />
												</v-col>
												<v-col cols="12">
													<v-row class="flex-column sms-row" v-show="appSettings.isRememberSmsActive">
														<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0 pb-0">
															<v-checkbox color="secondary" v-show="appSettings.isRememberSmsActive" v-model="appSettings.isDueDateSmsActive" :label="'پیامک یادآوری روز سررسید ارسال شود؟'" />
														</v-col>
														<v-col cols="12" md="6" class="text-center pb-0 grey--text" v-show="appSettings.isDueDateSmsActive">
															قالب پیامک یادآوری سررسید:
														</v-col>
														<v-col cols="12" md="6" class="pt-0" v-show="appSettings.isDueDateSmsActive">
															<v-combobox v-model="appSettings.dueDateRememberSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<sms-pattern :data="appSettings.dueDateRememberSmsPattern" :onlySample="true" />
														</v-col>
													</v-row>
													<v-row class="flex-column sms-row" v-show="appSettings.isRememberSmsActive">
														<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0 pb-0">
															<v-checkbox color="secondary" v-show="appSettings.isRememberSmsActive" v-model="isBeforeDueDateSmsActive" :label="'پیامک یادآوری سررسید پیش از موعد ارسال شود؟'" />
														</v-col>
														<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
															<div class="grey--text" v-show="isBeforeDueDateSmsActive">
																پیامک یادآوری سررسید پیش از موعد چند روز قبل از سررسید ارسال شود؟
															</div>
															<v-text-field class="center-input" v-show="isBeforeDueDateSmsActive" v-model="appSettings.beforeDueDaysCount" :error-messages="errorMessages" maxlength="3" :rules="[() => appSettings.beforeDueDaysCount >= 0 || 'تعداد روز نمی تواند کمتر از 0 باشد']" />
														</v-col>
														<v-col cols="12" md="6" class="text-center pb-0 grey--text" v-show="isBeforeDueDateSmsActive">
															قالب پیامک سررسید پیش از موعد:
														</v-col>
														<v-col cols="12" md="6" class="pt-0" v-show="isBeforeDueDateSmsActive">
															<v-combobox v-model="appSettings.beforeDueDateSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<sms-pattern :data="appSettings.beforeDueDateSmsPattern" :onlySample="true" />
														</v-col>
													</v-row>
													<v-row class="flex-column sms-row" v-show="appSettings.isRememberSmsActive">
														<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
															<div class="grey--text">
																پیامک اقساط معوق چند روز پس از سررسید ارسال شود؟
															</div>
															<v-text-field class="center-input" v-model="appSettings.overDueDaysCount" :error-messages="errorMessages" maxlength="3" :rules="[() => appSettings.overDueDaysCount >= 0 || 'تعداد روز نمی تواند کمتر از 0 باشد']" />
														</v-col>
														<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
															<v-checkbox color="secondary" v-model="appSettings.overDueDayRemeberOnce" :label="'پیامک یادآوری معوق تا زمان وصول هر روز ارسال شود؟'" />
														</v-col>
														<v-col cols="12" md="6" class="text-center pb-0 grey--text">
															قالب پیامک اقساط معوق شده:
														</v-col>
														<v-col cols="12" md="6" class="pt-0">
															<v-combobox v-model="appSettings.overDueDateSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<sms-pattern :data="appSettings.overDueDateSmsPattern" :onlySample="true" />
														</v-col>
													</v-row>
												</v-col>
											</v-row>

											<v-row class="flex-column sms-row">
												<v-col cols="12" md="6" class="text-center pb-0 grey--text">
													قالب پیامک ثبت قسط و تشکر:
												</v-col>
												<v-col cols="12" md="6" class="pt-0">
													<v-combobox v-model="appSettings.thanksPaymentSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
													<sms-pattern :data="appSettings.thanksPaymentSmsPattern" :onlySample="true" />
												</v-col>
											</v-row>

											<v-row class="flex-column sms-row">
												<v-col cols="12" md="6" class="text-center pb-0 grey--text">
													قالب پیامک ورود به سیستم:
												</v-col>
												<v-col cols="12" md="6" class="pt-0">
													<v-combobox v-model="appSettings.loginSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
													<sms-pattern :data="appSettings.loginSmsPattern" :onlySample="true" />
												</v-col>
											</v-row>

											<v-row class="flex-column sms-row">
												<v-col cols="12" md="6" class="text-center pb-0 grey--text">
													قالب پیامک رمز تاییدیه ثبت نام:
												</v-col>
												<v-col cols="12" md="6" class="pt-0">
													<v-combobox v-model="appSettings.registerOtpSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
													<sms-pattern :data="appSettings.registerOtpSmsPattern" :onlySample="true" />
												</v-col>
											</v-row>

											<v-row class="flex-column sms-row">
												<v-col cols="12" md="6" class="text-center pb-0 grey--text">
													قالب پیامک خوش آمد ثبت نام:
												</v-col>
												<v-col cols="12" md="6" class="pt-0">
													<v-combobox v-model="appSettings.registerSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
													<sms-pattern :data="appSettings.registerSmsPattern" :onlySample="true" />
												</v-col>
											</v-row>


										</v-card>
									</v-form>
								</v-col>
							</v-row>
						</v-tab-item>

					</v-tabs-items>
				</v-tabs>
			</div>
		</material-card>

		<confirm-dlg ref="confirm" />

		<div class="py-3" />

		<v-dialog v-model="dialogSmsPatternManager" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت قالب های پیامک</span></div>
					<v-spacer />
					<v-btn @click="dialogSmsPatternManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<sms-pattern-manager ref="smsPatternManager" v-if="dialogSmsPatternManager" @itemsUpdated="updatePatterns" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSmsCreditCharge" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">شارژ اعتبار پیامک</span></div>
					<v-spacer />
					<v-btn @click="dialogSmsCreditCharge = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<sms-credit-charge ref="smsCreditCharge" v-if="dialogSmsCreditCharge" @callbck="callbck_smsCreditCharge" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'MembersView',
		props: {
			mobile: { type: String },
			autoLoad: { type: Boolean, default: true },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'date-navigator': () => import('@/components/DateNavigator'),
			'sms-credit-charge': () => import('@/components/forms/SmsCreditCharge.vue'),
			'sms-pattern-manager': () => import('@/components/SmsPatternManager.vue'),
			'sms-pattern': () => import('@/components/SmsPattern.vue'),
			'sms-list': () => import('@/views/admin/SMSList.vue')
		},
		data() {
			return {
				isBeforeDueDateSmsActive: false,
				dialogSmsCreditCharge: false,
				dialogSmsPatternManager: false,
				errorMessages: '',
				time: '',
				appSettings: { dashboardSettings: {} },
				smsPatterns: [],
				activeTab: 0,
				loading: false,
				rowLoading: '',
				smsPanels: [
					{ id: 1, title: 'جت اقساط' },
					{ id: 2, title: 'ملی پیامک' },
					{ id: 3, title: 'کاوه نگار' },
				],
			}
		},
		computed: {
			...get('siteConfig', [
				'isCloud'
			]),
		},
		created() {

		},
		mounted() {
			this.loadAppSettings()
			this.loadSmsPatterns()
		},
		methods: {
			...call('appSettings/*'),
			saveSmsSettings() {
				this.loading = true
				if (!this.appSettings.isRememberSmsActive)
					this.appSettings.dueDatedRememberSmsTime = null
				if (!this.isBeforeDueDateSmsActive)
					this.appSettings.beforeDueDaysCount = 0
				var data = _.cloneDeep(this.appSettings)
				data.overDueDayRemeberOnce = !this.appSettings.overDueDayRemeberOnce
				data.isRememberSmsActive = !!this.appSettings.isRememberSmsActive
				if (this.appSettings.defaultSmsPanel)
					data.defaultSmsPanel = this.appSettings.defaultSmsPanel.id
				this.sync(data).then(x => {
					this.loading = false
					toast.success('اطلاعات با موفقیت ذخیره شد.')
				}).catch(err => {
					this.loading = false
					toast.error(err.message)
				})
			},
			loadAppSettings() {
				this.fetch({ force: true }).then(x => {
					this.appSettings = x
					this.isBeforeDueDateSmsActive = !!this.appSettings.beforeDueDaysCount
					this.appSettings.overDueDayRemeberOnce = !this.appSettings.overDueDayRemeberOnce
					this.appSettings.defaultSmsPanel = this.smsPanels.find(x => x.id == this.appSettings.defaultSmsPanel)
				})
			},
			addSmsCreditCharge() {
				this.dialogSmsCreditCharge = true
			},
			callbck_smsCreditCharge() {
				this.dialogSmsCreditCharge = false
			},
			loadSmsPatterns() {
				api.get('admin/smsPattern/list', null)
					.then(
						response => {
							this.smsPatterns = response.filter(x => x.status === 1)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
					})
			},
			updatePatterns(items) {
				this.smsPatterns = items.filter(x => x.status === 1)
			}
		},
	}
</script>
<style scoped>
	.sms-row {
		justify-content: center;
		align-items: center;
		background-color: whitesmoke;
		border-radius: 10px;
		margin: 15px 0;
		padding: 10px 0;
		border: 1px solid #dca6e5;
	}
</style>